import { createReducer, on } from '@ngrx/store';
import {
  incrementCodeAttempt,
  resetCodeAttempt
} from '../actions/otp-code-attempts.actions';
import { IOtpCodeAttemptsState } from '../interfaces/otp-code-attempts-state.interface';

export const initialState: IOtpCodeAttemptsState = { counter: 0 };

const _otpCodeAttemptReducer = createReducer(
  initialState,
  on(incrementCodeAttempt, (state) => ({
    ...state,
    counter: state.counter + 1
  })),

  on(resetCodeAttempt, (state) => ({
    ...state,
    counter: 0
  }))
);

export function otpCodeAttemptReducer(state: any, action: any) {
  return _otpCodeAttemptReducer(state, action);
}
